/**
 * OCEAN tracking: ordinary trackClick calls (PostHog `utech_click` + the
 * site_events mirror), every action prefixed `ocean_`:
 *   ocean_view                      page shown
 *   ocean_search                    keyword/filters submitted {q_len, goals, countries, industries, tags, hits}
 *   ocean_filter                    a filter toggled {kind, value, on}
 *   ocean_suggestion                an empty-state suggestion used {type}
 *   ocean_history_replay            a history entry re-run
 *   ocean_open                      a card or drawer opened {kind, from}
 *   ocean_save / ocean_unsave       {kind, collection: default | last_used | picked | new, from?}
 *   ocean_move                      a saved card moved to another collection {kind, from: picker | profile}
 *   ocean_save_change               the save toast's "Change" {kind}
 *   ocean_picker_open               the card's collection chevron {kind, saved}
 *   ocean_collection_create         {from: picker | profile | move | ocean}
 *   ocean_collection_rename / _delete {moved, shared} / _open {from: profile | share_link}
 *   ocean_collection_share_link     a collection's link made or reused {created, cards}
 *   ocean_collection_share(_open)   its share menu: opened / a channel used {channel, target_kind}
 *   ocean_collection_unshare        "Stop sharing"
 *   ocean_share                     {kind}
 *   ocean_source_open               "View original source" {type}
 *   source_open / source_blocked / source_open_new_tab / source_close / source_resize
 *                                   the in-app source pane (components/common/SourcePane.tsx),
 *                                   surface 'ocean_problem' {domain, card_id, card_kind, source_type,
 *                                   position, link, …}; unprefixed, shared with What's New
 *   ocean_invite_send               {count, sent, existing}
 */
import { trackClick } from '../../utils/analytics';

export const ocTrack = (action: string, props?: Record<string, unknown>): void => {
  try { trackClick(action, { page: 'ocean', ...(props || {}) }); } catch { /* never break a click */ }
};
